<template>
  <v-progress-linear
    absolute
    :active="progressLinear"
    indeterminate
  ></v-progress-linear>
</template>
<script>
export default {
  computed: {
    progressLinear() {
      return this.$store.state.progressLinear;
    },
  },
};
</script>